<script setup>
import { createDescriptionMarkup } from "@/api/httpApi";

const props = defineProps(["resource", "id", "name", "isInvalid", "isSelected", "yupErrorIdContainer"]);
defineEmits(["change"]);
</script>
<style scoped>
.isInvalid {
  border-bottom: 1px solid #d9364f;
}
</style>
<template>
  <div class="bg-white p-4 mt-4 control-wrapper" :id="`control-wrapper-` + props.id">
    <div class="d-flex mb-3" :class="{ 'isInvalid': isInvalid }">
      <h3 class="h4" style="flex: 1">{{ props.resource.name }}</h3>
      <input
        :id="props.id"
        :name="props.name"
        type="radio"
        style="width: 1.5rem; height: 1.5rem;"
        :checked="isSelected"
        :value="props.resource.resourceId"
        :aria-label="props.resource.name"
        data-yup-label="Servizi"
        :data-yup-error-id-label="props.yupErrorIdContainer"
        :data-yup-error-id-field="`control-wrapper-`+ props.id"
        @change="
          (e) => {
            $emit('change', props.resource.resourceId);
          }
        "
      />
    </div>
    <small class="fw-normal">Descrizione</small>
    <p
      class="fw-bold mb-3"
      v-html="createDescriptionMarkup(props.resource.description)"
    ></p>
    <div class="border-top mb-2" style="height: 0.5rem">&nbsp;</div>
    <small class="fw-normal">Sede</small>
    <p class="fw-bold mb-3">{{ props.resource.place }}</p>
    <div class="border-top" style="height: 0.5rem">&nbsp;</div>
  </div>
</template>
